var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "form",
    {
      class: {
        "table-display": !_vm.isTilesDisplay,
      },
      attrs: {
        id: "module-list",
      },
    },
    [
      _vm.highlighted.length > 0
        ? _c(
            "div",
            {
              staticClass: "infopanel",
            },
            [
              _c("div", {
                staticClass: "top",
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "navigation_wrapper",
                },
                [
                  _vm.highlightIndex > 0
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            title: "$gettext('Vorheriges Inhaltselement')",
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              _vm.highlightIndex--
                            },
                          },
                        },
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: "arr_1left",
                              size: 20,
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "contentmodule",
                      attrs: {
                        href: _vm.getDescriptionURL(_vm.highlightedModule),
                        "data-dialog": "",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "iconwrapper",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.highlightedModule.icon,
                              width: "60",
                              height: "60",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "title",
                            },
                            [_vm._v(_vm._s(_vm.highlightedModule.toolname))]
                          ),
                          _vm._v(" "),
                          _vm.highlightedModule.highlight_text
                            ? _c("div", {}, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.highlightedModule.highlight_text
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.highlightIndex < _vm.highlighted.length - 1
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            title: _vm.$gettext("Nächstes Inhaltselement"),
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              _vm.highlightIndex++
                            },
                          },
                        },
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: "arr_1right",
                              size: 20,
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div"),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(_vm.displayComponent, {
        tag: "component",
        attrs: {
          modules: _vm.modules,
          filtercategory: _vm.filterCategory,
        },
      }),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            "mount-to":
              "#tool-view-switch .sidebar-widget-content .widget-list",
            name: "sidebar-switch",
          },
        },
        [
          _c(
            "ul",
            {
              staticClass: "widget-list widget-links sidebar-views",
            },
            [
              _c(
                "li",
                {
                  class: {
                    active: _vm.view === "tiles",
                  },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.changeView("tiles")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Kachelansicht")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: {
                    active: _vm.view === "table",
                  },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "#",
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.changeView("table")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Tabellarische Ansicht")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            "mount-to":
              "#tool-filter-category .sidebar-widget-content .widget-list",
            name: "sidebar-filter",
          },
        },
        [
          _c(
            "ul",
            {
              staticClass: "widget-list widget-options",
            },
            [
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "options-radio",
                    class:
                      _vm.filterCategory === null
                        ? "options-checked"
                        : "options-unchecked",
                    attrs: {
                      role: "radio",
                      "aria-checked":
                        _vm.filterCategory === null ? "true" : "false",
                      href: "#",
                    },
                    on: {
                      click: function click($event) {
                        $event.preventDefault()
                        return _vm.setFilterCategory(null)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$gettext("Alle Kategorien")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.categories, function (category) {
                return _c(
                  "li",
                  {
                    key: category,
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "options-radio",
                        class:
                          _vm.filterCategory === category
                            ? "options-checked"
                            : "options-unchecked",
                        attrs: {
                          href: "#",
                          role: "radio",
                          "aria-checked":
                            _vm.filterCategory === category ? "true" : "false",
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.setFilterCategory(category)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(category) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }